import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface NotificacionData {
  tipo: string;
  mensaje: string;
  boton?: {
    texto: string;
    accion: () => void;
  };
}
@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { notificaciones: NotificacionData[] } = { notificaciones: [] }
  ) {}

  cerrar() {
    this.dialogRef.close();
  }

  ejecutarAccion(boton: { texto: string; accion: () => void }) {
    this.dialogRef.close();
    if (boton?.accion) boton.accion();
  }
}